import { ResourceType } from '@alexandrainst/plana-react-api'

export const resourceKeys = <T extends ResourceType>(type: T) => ({
  all: [{ entity: type }] as const,
  lists: (resourceGroupFilter: string[]) =>
    [
      ...resourceKeys(type).all,
      { scope: 'list' },
      { resourceGroupFilter },
    ] as const,
  bySourceScope: () =>
    [...resourceKeys(type).all, { scope: 'bySource' }] as const,
  bySourceListsType: (sourceType: ResourceType) =>
    [
      ...resourceKeys(type).bySourceScope(),
      {
        sourceType,
      },
    ] as const,
  bySource: (
    sourceType: ResourceType,
    sourceId: string,
    from: string,
    to: string,
    resourceGroupFilter: string[]
  ) =>
    [
      ...resourceKeys(type).bySourceScope(),
      {
        sourceType,
        sourceId,
        from,
        to,
        resourceGroupFilter,
      },
    ] as const,
  detailsScope: () =>
    [...resourceKeys(type).all, { scope: 'details' }] as const,
  details: (id: string) =>
    [...resourceKeys(type).detailsScope(), { id }] as const,
})

export const translationKeys = <T extends ResourceType | 'ui'>(entity: T) => ({
  all: [{ entity }] as const,
  translationScope: () =>
    [...translationKeys(entity).all, { scope: 'translation' }] as const,

  key: (key: string) =>
    [...translationKeys(entity).translationScope(), { key }] as const,

  attributeService: (service: 'help' | 'name') =>
    [...translationKeys(entity).translationScope(), { service }] as const,
  attributeHelp: (id: string) =>
    [...translationKeys(entity).attributeService('help'), { id }] as const,
  attributeName: (id: string) =>
    [...translationKeys(entity).attributeService('name'), { id }] as const,
})

export const renderingKeys = <T extends ResourceType>(type: T) => ({
  all: [{ entity: type }] as const,
  renderingScope: () =>
    [...renderingKeys(type).all, { scope: 'rendering' }] as const,

  attribute: (attributeId: string, resourceId: string) =>
    [
      ...renderingKeys(type).renderingScope(),
      { attributeId, resourceId },
    ] as const,
  attributeBatch: (attributeId: string, resourceIds: string[]) =>
    [
      ...renderingKeys(type).renderingScope(),
      { attributeId, resourceIds },
    ] as const,
})
